import {
  buildStyles,
  CircularProgressbar as Progressbar,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export type CircularProgressbarProps = {
  value: number;
  minValue?: number;
  maxValue?: number;
  text?: string;
  className?: string;
  pathColor?: string;
  textColor?: string;
  strokeWidth?: number;
};

function cssVar(name: string, el: HTMLElement = document.documentElement) {
  return getComputedStyle(el).getPropertyValue(name).trim();
}

export const CircularProgressbar = ({ ...props }: CircularProgressbarProps) => {
  const textColor = props.textColor
    ? cssVar(props.textColor)
    : cssVar("--color-text-primary");
  return (
    <Progressbar
      {...props}
      styles={buildStyles({
        pathColor: props.pathColor || "#4f49ba",
        textColor: textColor,
      })}
    />
  );
};
